var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wishcard-small",
      class: {
        "wishcard-small--show-preview": _vm.hasImage,
        "wishcard-small--has-error": _vm.hasErrors
      }
    },
    [
      _c("div", { staticClass: "wishcard-small__inner-left" }, [
        _c("h4", {
          staticClass: "wishcard-small__label",
          domProps: {
            textContent: _vm._s(_vm.$t("wishcard.inner_side.left") + ":")
          }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "wishcard-small__image card-image",
          style: _vm.imageStyles
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wishcard-small__inner-right" },
        [
          _c("h4", {
            staticClass: "wishcard-small__label",
            domProps: {
              textContent: _vm._s(_vm.$t("wishcard.inner_side.right") + ":")
            }
          }),
          _vm._v(" "),
          _c(
            "tg-wishcard-textarea",
            _vm._b(
              {
                attrs: { "show-default-placeholder": false },
                on: { validate: _vm.onValidate }
              },
              "tg-wishcard-textarea",
              _vm.$props,
              false
            )
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }